var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "client-logo", attrs: { title: _vm.name } },
    [
      _c(
        _vm.linkComponent,
        {
          tag: "component",
          staticClass: "u-reset client-logo--link",
          attrs: { path: _vm.link, external: true }
        },
        [
          _c(
            "dyn-picture-element",
            _vm._b({}, "dyn-picture-element", _vm.image, false)
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bb1f3d7", { render: render, staticRenderFns: staticRenderFns })
  }
}